/* eslint-disable */
import details_by_code from "@/apollo/packages/create/details_by_code.gql";
import create_package from "@/apollo/packages/create/create_package.gql";
import update_package from "@/apollo/packages/create/update_package.gql";
import field_values from "@/apollo/packages/create/field_values.gql";
import manage_options from "@/apollo/packages/create/manage_options.gql";

export const state = () => ({
  details: {},
  is_loading: false,
  is_creating: false,
  status: ["available", "static", "request", "sold"]
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 12 Apr 2024 | 11:42AM
   * @param {*} state
   * @param {*} value
   */
  set_details(state, value) {
    state.details = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 12 Apr 2024 | 11:42AM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.is_loading = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 27 Apr 2024 | 06:31PM
   * @param {*} state
   * @param {*} value
   */
  setCreateLoading(state, value) {
    state.is_creating = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 05 Oct 2024 | 11:18AM
   * @param {*} state
   * @param {*} { field, value }
   */
  updateFieldValue(state, { field, value }) {
    state.details[field] = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 27 Apr 2024 | 06:30PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  create({ commit }, payload) {
    commit("setCreateLoading", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .mutate({ mutation: create_package, variables: { payload } })
        .then(({ data }) => {
          commit("setCreateLoading", false);
          resolve(data.pkgCreate);
        })
        .catch(() => commit("setCreateLoading", false));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 29 Apr 2024 | 12:15PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  update({ commit }, payload) {
    commit("setCreateLoading", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .mutate({ mutation: update_package, variables: { payload } })
        .then(({ data }) => {
          commit("setCreateLoading", false);
          resolve(data.pkgUpdate);
          /*  this.fetchDetails(payload); */
        })
        .catch(() => commit("setCreateLoading", false));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 12 Apr 2024 | 11:44AM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  fetchDetails({ commit }, payload) {
    commit("set_details", {});
    commit("setLoading", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: details_by_code, variables: { ...payload } })
        .then(({ data }) => {
          commit("set_details", data.pkgDetailsByCode);
          resolve(data.pkgDetailsByCode);
          commit("setLoading", false);
        })
        .catch(() => commit("setLoading", false));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 06 May 2024 | 04:06PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  fetchFieldValue({ commit }, payload) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: field_values, variables: { ...payload } }).then(({ data }) => resolve(data.pkgFieldValues));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 10 May 2024 | 10:21AM
   * @param {*} payload
   * @returns {*}
   */
  manageOptions(__, payload) {
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .mutate({ mutation: manage_options, variables: { payload } })
        .then(({ data }) => resolve(data.pkgManageOptions))
        .catch((e) => reject(e));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Sep 2024 | 12:43PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  refreshUpdate({ commit }, payload) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { refresh_pkg_create_tab_data }`
      });
      for await (const event of _result) {
        if (payload?.pkg_code == event?.data?.refresh_pkg_create_tab_data?.code?.toLowerCase())
          this.$apolloClient.query({ query: details_by_code, variables: payload }).then(({ data }) => {
            commit("set_details", data.pkgDetailsByCode);
            resolve(data.pkgDetailsByCode);
          });
      }
    });
  }
};

export const getters = {
  status: (state) => state.status,
  details: (state) => state.details,
  is_loading: (state) => state.is_loading,
  is_creating: (state) => state.is_creating
};
